module.exports = __webpack_public_path__ + "img/4.3ab86a3c.jpg";